import type { GroundDecalDef } from '@/world-prototype/objects/groundDecal';

/**
 * Holly Springs (raleigh) backyard ground decals.
 *
 * Reuses the Hubert patio sprite; layouts are independent.
 * Layouts: `layouts.desktop` / `layouts.tablet` / `layouts.mobile`. Flat fields
 * mirror desktop. Updated by World Editor (?edit=1).
 */
const BACKYARD_GROUND = `${import.meta.env.BASE_URL}art/environments/jacksonville/backyard/ground`;

export const RALEIGH_GROUND_DECAL_DEFS: readonly GroundDecalDef[] = [
  {
    id: "patio",
    title: "Patio",
    enabled: true,
    x: 0.42979,
    y: 0.9278,
    widthFrac: 0.6943,
    rotationDeg: -0.26,
    layouts: {
      desktop: {
        x: 0.42979,
        y: 0.9278,
        widthFrac: 0.6943,
        rotationDeg: -0.26,
        quadCorners: [
          { x: -0.2805, y: -0.0712 },
          { x: 0.3083, y: -0.0707 },
          { x: 0.3469, y: 0.0771 },
          { x: -0.2827, y: 0.0707 },
        ],
      },
      tablet: {
        x: 0.35809,
        y: 0.93585,
        widthFrac: 0.603,
        quadCorners: [
          { x: -0.2234, y: -0.0614 },
          { x: 0.268, y: -0.0614 },
          { x: 0.3015, y: 0.067 },
          { x: -0.2457, y: 0.0614 },
        ],
      },
      mobile: {
        x: 0.44903,
        y: 0.77045,
        widthFrac: 0.6498,
        quadCorners: [
          { x: -0.2407, y: -0.0662 },
          { x: 0.2888, y: -0.0662 },
          { x: 0.3249, y: 0.0722 },
          { x: -0.2648, y: 0.0662 },
        ],
      },
    },
    quadCorners: [
      { x: -0.2805, y: -0.0712 },
      { x: 0.3083, y: -0.0707 },
      { x: 0.3469, y: 0.0771 },
      { x: -0.2827, y: 0.0707 },
    ],
    sprite: {
      src: `${BACKYARD_GROUND}/patio-v1.png`,
      alt: "Concrete patio",
      imageWidth: 1013,
      imageHeight: 130,
    },
    footprint: [],
  },
];
